import { render, staticRenderFns } from "./AppGroupItem.vue?vue&type=template&id=44df3523&lang=pug&"
import script from "./AppGroupItem.vue?vue&type=script&lang=js&"
export * from "./AppGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./AppGroupItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports